module.exports = __webpack_public_path__ + "img/contentful.e2371722.png";